<template>
  <div class="page-wrapper">
    <AppHeader title="Unsynced Invoices" />
    <div class="container-fluid">
      <div class="container-fluid left">
        <div class="row topnav" style="padding-left: 15px">
          <!-- <div class="col-sm-1">
            <div
              class="dropdown"
              style="
                position: fixed;
                left: 0;
                top: 0;
                padding: 0;
                margin-top: 0;
                margin-bottom: 0;
              "
            >
              <MainMenu />
            </div>
          </div> -->
          <div class="col-sm-12">
            <div class="touch-search-header">
              <div class="touch-search-area">
                <div class="input-group touch-search-group">
                  <span class="input-group-addon">
                    <i class="glyphicon glyphicon-search"></i>
                  </span>
                  <input
                    type="text"
                    ref="order_id"
                    v-on:keyup.enter="getOrder(order_id)"
                    v-model="order_id"
                    id="order_id"
                    name="order_id"
                    class="form-control input-lg"
                    placeholder="Enter Invoice Number"
                  />
                  <span class="input-group-btn">
                    <button
                      class="btn btn-success btn-lg"
                      @click="getOrder(order_id)"
                    >
                      Search
                    </button>
                  </span>
                </div>
              </div>
            </div>
            <div v-show="showError" style="text-align: center">
              <label class="h3" style="color: maroon">
                {{ this.mainErrorMsg }}
              </label>
            </div>
          </div>
      </div>
      <div v-if="toggle">
        <br />
        <div
          v-if="toggle && !loading"
          class="row table-wrap"
          style="color: #fff; "
        >
          <table class="table" style="color: #fff">
            <thead>
              <tr>
                <th style="font-size: 1.5em">Invoice Number</th>

                <th style="font-size: 1.5em">Created At</th>
                <th style="font-size: 1.5em">Sync Error Message</th>
                <th style="font-size: 1.5em"></th>

              </tr>
            </thead>
            <tbody>
              <tr v-for="machine in allMachines" :key="machine.id">
                <td style="font-size: 1.3em">{{ machine.invoice }}</td>
                <td style="font-size: 1.3em">{{ machine.createdOn }}</td>
                <td style="font-size: 1.3em">
                  {{ machine.efris_error_message }}
                </td>
                <td>
                  <button
                    class="btn btn-success"
                    style="font-size: 1.2em"
                    @click="syncInvoice(machine.invoice)"
                  >
                    ReSync
                  </button>
                </td>

              </tr>
            </tbody>
          </table>
          <ul class="pagination">
            <li class="page-item" :class="{ disabled: page === 1 }">
              <a class="page-link" href="#" @click="goToPage(page - 1)"
                >Previous</a
              >
            </li>

            <li v-if="page > 3">
              <a class="page-link" href="#" @click="goToPage(1)">1</a>
            </li>

            <li v-if="page > 4">
              <span class="page-link">...</span>
            </li>

            <li
              v-for="pageNumber in visiblePages"
              :key="pageNumber"
              :class="{ active: page === pageNumber }"
            >
              <a class="page-link" href="#" @click="goToPage(pageNumber)">{{
                pageNumber
              }}</a>
            </li>

            <li v-if="page < totalPages - 3">
              <span class="page-link">...</span>
            </li>

            <li v-if="page < totalPages - 2">
              <a class="page-link" href="#" @click="goToPage(totalPages)">{{
                totalPages
              }}</a>
            </li>

            <li class="page-item" :class="{ disabled: page === totalPages }">
              <a class="page-link" href="#" @click="goToPage(page + 1)">Next</a>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
  </div>
</template>

<script>
import axios from "axios";
import commonServices from "@/shared/commonServices";
import MainMenu from "@/components/MainMenu";
import Datepicker from "vuejs3-datepicker";
import "vue-date-pick/dist/vueDatePick.css";
import { mapGetters } from "vuex";
import AppHeader from "@/components/AppHeader";

export default {
  computed: {
    totalPages() {
      if (this.totalLength) {
        return Math.ceil(this.totalLength / 15);
      }
      return 0;
    },
    visiblePages() {
      let startPage = Math.max(1, this.page - 2);
      let endPage = Math.min(this.totalPages, startPage + 4);

      if (endPage - startPage < 4) {
        startPage = Math.max(1, endPage - 4);
      }

      return Array.from(
        { length: endPage - startPage + 1 },
        (_, i) => startPage + i
      );
    },
    ...mapGetters({
      modules: "modules_options/modulesPers",
      machinePermissions: "modules_options/machinePermissions",
    }),
  },
  mixins: [commonServices],
  mounted() {
    //   this.getActivePromotions();
    this.getAllInvoices();
    if (localStorage.userId !== undefined && localStorage.appId !== undefined) {
    } else {
      this.$router.push({ name: "login" });
    }
    this.language = "ar";
    this.logoImage =
      '<img src="' + this.logoUrl + '" width="70" height="50" alt="Logo">';
  },
  components: { MainMenu, Datepicker ,AppHeader },
  data: function () {
    return {
      modulePermissions: [],
      state: { start_date: new Date(2016, 9, 16) },
      stateEnd: { end_date: new Date(2016, 9, 16) },
      showAddPromotion: false,
      showDuplicatePromotion: false,
      showPermissions: false,
      totalLength: 0,
      page: 1,
      promotions: [],
      allMachines: [],
      machineJson: {},
      promotionJson: {},
      promotionInfos: {},
      machineId: -1,
      promoition_name: "",
      start_date: "",
      end_date: "",
      minimum_total: "",
      percentage: "",
      name: "",
      authorizedToChangePrice: "N",
      isVoidOpen: false,
      ip: "",
      repeat_ip: "",
      reports_ok: false,
      showError: false,
      logoImage: "",
      mainErrorMsg: "",
      logoUrl: "",
      jsonData: {},
      language: "en",
      languageName: "",
      toggle: true,
      showInvoices: false,
      showPayments: false,
      addresses: [],
      selectedcustomers: [],
      customer_invoices: [],
      loading: false,
      customer_payments: [],
      customersJson: {},
      name: "",
      gender: "",
      email: "",
      phone: "",
      totalpoints: "",
      dis_percentage: "",
      status: "",
      creditstatus: "",
      date_added: "",
      aaddressid: 0,
      addressLine1: "",
      addressLine2: "",
      addressArea: "",
      addressCity: "",
      isDefault: false,
      customerAddresses: [],
      showAddress: false,
      findcustomer: "",
      findcustomername: "",
      customeraddress: {},
      order_id: "",
      machinePerms: [],
    };
  },
  methods: {
    goToPage(page) {
      if (page >= 1 && page <= this.totalPages) {
        this.page = page;
        this.getAllInvoices();
      }
    },
    getOrder: async function (id) {
      let dataURL = this.apiURL + "Orders/getOrder";
      let orderJson = { appId: localStorage.appId, orderId: id };
      let response = await axios.post(dataURL, orderJson);
      if (response.data.status === "success") {
        let obj = response.data.results;
        this.allMachines = [obj];
      } else {
        await this.getAllInvoices();
      }
    },
    syncInvoice: async function (invoice_id) {
      try {
        this.showInfo("Processing Invoice With URA");
        let uraJson = {
          username: localStorage.username,
          invoiceId: invoice_id,
        };
        let dataURL = this.apiURL + "SendToEfris/syncSalesInvoice";
        let response = await axios.post(dataURL, uraJson);
        let i = this.allMachines.findIndex((el) => el.invoice == invoice_id);
        if (response.data.status === "success") {
          this.showSuccess("Synced To URA");
          this.allMachines.splice(i, 1);
        } else {
          this.showAlert("Error Syncing With URA: " + response.data.errorMsg);
          this.allMachines[i].efris_error_message = response.data.errorMsg;
        }
      } catch (err) {
        this.showAlert("Error Syncing With URA");
      }
    },

    getAllInvoices: async function () {
      this.loading = true;
      this.machineJson.appId = localStorage.appId;
      this.machineJson.offset = (this.page - 1) * 15;
      try {
        let dataURL = this.apiURL + "Orders/getAllUnSyncedInvoices";
        let response = await axios.post(dataURL, this.machineJson);

        this.allMachines = response.data.results;
        this.totalLength = response.data.total_length;
        this.loading = false;
      } catch (error) {
        console.log(error);
        this.loading = false;
      }
      return this.allMachines;
    }
  },
};
</script>
<style>
#app {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: left;
  color: #2c3e50;
  margin-top: 20px;
}

.glyphicon.glyphicon-ok {
  font-size: 30px;
}

.button {
  font: bold 15px Arial;
  text-decoration: none;
  background-color: #eeeeee;
  color: #333333;
  /* padding: 2px 6px 2px 6px;
  border-top: 1px solid #cccccc;
  border-right: 1px solid #333333;
  border-bottom: 1px solid #333333;
  border-left: 1px solid #cccccc; */
}

.grid-container-element {
  display: grid;
  grid-template-columns: 5fr 1.5fr 1.5fr 1.5fr 0.5fr;
  grid-gap: 10px;
  border: 1px solid whitesmoke;
  border-left: 0px;
  border-right: 0px;
  border-top: 0px;
  width: 100%;
}

.grid-child-element_ {
  margin: 10px;
  border: 1px solid red;
}

.grid-child-element {
  margin: 2px;
  border-left: 0px;
  border-right: 0px;
  border-top: 0px;
  padding: 0 px;
}

.check-label {
  color: #fff;
  font-size: 1.5rem;
  margin-left: 1rem;
  margin: 1rem 0;
}
</style>
